import React, { ChangeEvent } from 'react';
import { FileInput } from '../file-input/file-input';
import { FormattedMessage } from 'react-intl';
import UploadButton, { FILE_TYPE } from '../upload-button';
import DefaultButton from '../../../../global/default-button/default-button';
import { REMOVE_TEXT } from '../../../../../constants/common-labels.constants';

export interface IUploadFileProps {
    file: File | { name: string } | null;
    fileType: FILE_TYPE;
    onChange: (e: File | File[]) => void | null;
    deleteFile: () => void | null;
    disabled?: boolean;
}

const UploadFile = (props: IUploadFileProps) => {
    const {
        file = null,
        disabled = true,
        fileType,
        onChange,
        deleteFile,
    } = props;

    const uploadFileHandler = (e: ChangeEvent<HTMLInputElement>) => {
        e.persist();
        onChange(e.target.files[0]);
        e.target.value = null;
    };

    return (
        <>
            {file ?
                <div className='image-input flex w-100 uploaded-img__controls'>
                    <input
                        className='oe-form-field__control m-right-11px uploaded-img__name--title'
                        type='text'
                        value={file.name}
                        disabled={disabled}
                    />
                    <FileInput
                        className='default-button--slim default-button--options m-right-5px'
                        type='default'
                        title={
                            <FormattedMessage
                                id='oe.common.replace'
                                description='Button label'
                                defaultMessage='Replace'
                            />
                        }
                        acceptedFileTypes={`.${fileType}`}
                        onChange={uploadFileHandler}
                    />
                    <DefaultButton
                        onClick={deleteFile}
                        text={<FormattedMessage {...REMOVE_TEXT} />}
                        modifier='remove'
                    />
                </div>
                :
                <UploadButton
                    onChange={onChange}
                    uploadedFileType={fileType}
                />
            }
        </>
    );
};

export default UploadFile;
